import { Icon } from 'components/Icon'
import { Spinner } from 'components/Spinner'
import { UserIntersect } from 'types'
import { parseInitialsFromUser, parseNameFromUser } from 'utils'
import React from 'react'

export type AvatarThumbProps = {
	user?:
		| (Pick<UserIntersect, 'imageUrl' | 'registered'> &
				Partial<Pick<UserIntersect, 'name' | 'lastName' | 'firstName'>>)
		| null
	isLoading?: boolean
}
export const AvatarThumb = ({ user, isLoading }: AvatarThumbProps) => {
	const { imageUrl } = user || {}

	return (
		<div className='avatar-thumb'>
			{isLoading ? <Spinner type='circle' /> : null}
			{user?.registered ? (
				<>
					{imageUrl ? (
						<img src={imageUrl} alt={`${parseNameFromUser(user)}`} />
					) : (
						<span className='user-initials'>{parseInitialsFromUser(user)}</span>
					)}
				</>
			) : (
				<>
					<Icon type='mWithQuestion' />
				</>
			)}
		</div>
	)
}
